<template>
  <div class="teacher">
    <div class="container">
      <div class="heading text-center">
        <h3>Our Teachers</h3>
      </div>
      <div class="row">
        <div class="col-md-4" v-for="(teacher, index) of teachers" :key="index">
          <div class="card mb-3" style="max-width: 540px;">
            <div class="row g-0">
              <div class="col-5">
                <img :src="url + '/uploads/pictures/' + teacher.picture.url" class="img-fluid" alt="teacher image">
              </div>
              <div class="col-7">
                <div class="card-body">
                  <h6>{{ teacher.joined }}</h6>
                  <h5 class="card-title">{{ teacher.firstName }} {{ teacher.familyName }}</h5>
                  <p class="job">{{ teacher.job }}</p>
                  <a href="#" class="facebook">
                    <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M5.05851 2.10741H6.1883V0.0893734C5.99338 0.0618739 5.32304 0 4.54235 0C2.91341 0 1.79755 1.0508 1.79755 2.98211V4.75953H0V7.01554H1.79755V12.6921H4.00143V7.01607H5.72628L6.00009 4.76006H4.00092V3.20581C4.00143 2.55375 4.17263 2.10741 5.05851 2.10741Z"
                          fill="white"/>
                    </svg>
                  </a>
                  <a href="#" class="insta">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M4.62066 7.63241e-07L9.26152 3.46928e-07C11.3971 1.55354e-07 13.1289 1.7761 13.1289 3.96627L13.1289 8.7258C13.1289 10.916 11.3971 12.6921 9.26152 12.6921L4.62066 12.6921C2.48509 12.6921 0.75327 10.916 0.75327 8.7258L0.75327 3.96627C0.753269 1.7761 2.48508 9.54814e-07 4.62066 7.63241e-07ZM1.91349 8.7258C1.91349 10.2568 3.12785 11.5022 4.62066 11.5022L9.26152 11.5022C10.7543 11.5022 11.9687 10.2568 11.9687 8.7258L11.9687 3.96627C11.9687 2.43529 10.7543 1.18988 9.26152 1.18988L4.62066 1.18988C3.12784 1.18988 1.91349 2.43529 1.91349 3.96627L1.91349 8.7258ZM6.94125 3.17383C8.64986 3.17383 10.0352 4.59455 10.0352 6.34685C10.0352 8.09915 8.64986 9.51987 6.94125 9.51987C5.23264 9.51987 3.84734 8.09915 3.84734 6.34685C3.84734 4.59455 5.23264 3.17383 6.94125 3.17383ZM6.94125 8.32999C8.0071 8.32999 8.87494 7.43995 8.87494 6.34685C8.87494 5.25295 8.0071 4.36371 6.94125 4.36371C5.8754 4.36371 5.00755 5.25295 5.00755 6.34685C5.00755 7.43995 5.8754 8.32999 6.94125 8.32999ZM3.20284 2.93452C3.20284 3.16803 3.38741 3.35733 3.61509 3.35733C3.84277 3.35733 4.02734 3.16803 4.02734 2.93452C4.02734 2.70102 3.84277 2.51172 3.61509 2.51172C3.38741 2.51172 3.20284 2.70102 3.20284 2.93452Z"
                            fill="white"/>
                    </svg>
                  </a>
                  <a href="#" class="twiter">
                    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M14.0727 2.09701C13.5759 2.32048 13.0466 2.4686 12.4948 2.54052C13.0625 2.1929 13.4958 1.64664 13.6995 0.988212C13.1702 1.31186 12.5858 1.54047 11.963 1.66804C11.4604 1.11921 10.7441 0.779297 9.96264 0.779297C8.44652 0.779297 7.22595 2.04135 7.22595 3.58853C7.22595 3.81114 7.24432 4.02519 7.2894 4.22897C5.01273 4.1151 2.9982 2.99603 1.64488 1.29131C1.40862 1.71171 1.27003 2.1929 1.27003 2.71091C1.27003 3.68357 1.75842 4.54577 2.48643 5.04494C2.04645 5.03638 1.61483 4.90538 1.24916 4.69903C1.24916 4.70759 1.24916 4.71873 1.24916 4.72986C1.24916 6.09466 2.1984 7.22828 3.44318 7.48943C3.22027 7.55193 2.97733 7.5819 2.7252 7.5819C2.54988 7.5819 2.37288 7.57162 2.20675 7.53395C2.56156 8.64617 3.56841 9.46385 4.76561 9.49039C3.8339 10.2379 2.65089 10.6882 1.37021 10.6882C1.14563 10.6882 0.930239 10.678 0.714844 10.6497C1.9279 11.452 3.36554 11.91 4.91588 11.91C9.95512 11.91 12.7102 7.62899 12.7102 3.91817C12.7102 3.79402 12.706 3.67415 12.7002 3.55513C13.2437 3.15956 13.7003 2.66553 14.0727 2.09701Z"
                          fill="white"/>
                    </svg>
                  </a>
                  <a href="#" class="youtube">
                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M13.7232 2.02487C13.5693 1.43318 13.1181 0.966759 12.5459 0.807436C11.5007 0.511719 7.31939 0.511719 7.31939 0.511719C7.31939 0.511719 3.13829 0.511719 2.093 0.796224C1.53183 0.955379 1.06964 1.43326 0.915707 2.02487C0.640625 3.10557 0.640625 5.34679 0.640625 5.34679C0.640625 5.34679 0.640625 7.59932 0.915707 8.66872C1.0698 9.26033 1.52082 9.72675 2.09308 9.88607C3.1493 10.1819 7.31955 10.1819 7.31955 10.1819C7.31955 10.1819 11.5007 10.1819 12.5459 9.89736C13.1182 9.73813 13.5693 9.27171 13.7234 8.6801C13.9984 7.59932 13.9984 5.35817 13.9984 5.35817C13.9984 5.35817 14.0094 3.10557 13.7232 2.02487ZM5.98817 7.41732V3.27627L9.46509 5.34679L5.98817 7.41732Z"
                          fill="white"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      teachers: [],
      url: process.env.VUE_APP_ROOT_IMAGES_API,
    }
  },
  props: ['id'],
  async mounted() {
    await axios.get(`/api/v3/teachers/${this.id}`)
        .then((response) => {
          this.teachers = response.data;
        })
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/categories/styles.scss";

.teacher {
  background: url('~@/assets/categories/img/teacher-bg.png'), #00E384;
  padding: 92px 0;
  @media (min-width: $width1) and (max-width: $width2) {
    padding: 20px 0;
  }

  .heading {
    h3 {
      font-weight: 500;
      font-size: 36px;
      line-height: 107.19%;
      margin-bottom: 62px;
      @media (min-width: $width1) and (max-width: $width2) {
        font-size: 24px;
        margin-bottom: 38px;
      }
    }
  }

  .card {
    background: unset;
    border: none;
    margin-bottom: 42px !important;
    @media (min-width: $width1) and (max-width: $width2) {
      border-radius: 0;
      border-bottom: 1px solid #DDD;
      padding: 20px 0 30px;
      margin-bottom: 10px !important;
    }

    img {
      width: 100%;
      height: 100%;
      @media (min-width: $width1) and (max-width: $width2) {
        border-radius: 64px;
      }
    }

    .card-body {
      padding: 28px 20px;
      @media (min-width: $width1) and (max-width: $width2) {
        padding: 23px 20px;
      }

      h6 {
        font-weight: 500;
        margin-bottom: 3px;
        @media (min-width: $width1) and (max-width: $width2) {
          font-size: 12px;
        }
      }

      .card-title {
        font-weight: 500;
        font-size: 24px;
        margin-bottom: 4px;
        @media (min-width: $width1) and (max-width: $width2) {
          font-size: 18px;
        }
      }

      .job {
        background: linear-gradient(90deg, #FFFFFF 0%, #FFFFFF 222.91%);
        border-radius: 4px;
        font-weight: 500;
        font-size: 10px;
        margin-bottom: 3px;
        color: #00E384;
        width: fit-content;
        padding: 5px 8px;
        @media (min-width: $width1) and (max-width: $width2) {
          padding: 3.5px 6px;
        }
      }

      a {
        margin-right: 10px;

        svg {
          @media (min-width: $width1) and (max-width: $width2) {
            width: 10px;
          }
        }
      }
    }
  }
}
</style>
